import { useState } from "react";
import { CopyButton } from "./CopyButton";

type Os = "unix" | "windows";

// Renders a copy-ready one-liner with a macOS/Linux ↔ Windows toggle.
// Pass a single command (string) or per-OS commands.
export function CommandBlock({
  unix,
  windows,
  command,
}: {
  unix?: string;
  windows?: string;
  command?: string;
}) {
  const hasToggle = Boolean(unix && windows);
  const [os, setOs] = useState<Os>("unix");

  const value = command ?? (os === "unix" ? unix : windows) ?? "";

  return (
    <div className="overflow-hidden rounded-md border border-surface-300 bg-surface-50">
      <div className="flex items-center justify-between border-b border-white/10 px-3 py-2">
        {hasToggle ? (
          <div className="inline-flex overflow-hidden rounded-md border border-white/15 text-xs">
            <button
              className={`px-2.5 py-1 ${
                os === "unix" ? "bg-white/15 text-white" : "text-white/55"
              }`}
              onClick={() => setOs("unix")}
            >
              macOS / Linux
            </button>
            <button
              className={`px-2.5 py-1 ${
                os === "windows" ? "bg-white/15 text-white" : "text-white/55"
              }`}
              onClick={() => setOs("windows")}
            >
              Windows
            </button>
          </div>
        ) : (
          <span className="text-xs text-white/45">Command</span>
        )}
        <CopyButton
          text={value}
          className="btn px-2 py-1 text-xs text-white/80 hover:bg-white/10"
        />
      </div>
      <pre className="mono overflow-x-auto px-3 py-3 text-xs leading-relaxed text-white/90">
        <code>{value}</code>
      </pre>
    </div>
  );
}
